import { makeStyles } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';

import { ReactComponent as ArrowUp } from './arrow_up_icon.svg';

const useStyles = makeStyles({
  icon: {
    width: 24,
    height: 24,
    fill: '#3c3c3c',
    '& .st0': {
      fill: '#3c3c3c',
    },
  },
});

export default function ArrowUpIcon() {
  const classes = useStyles();

  return (
    <SvgIcon className={classes.icon} viewBox="0 0 24 24">
      <ArrowUp />
    </SvgIcon>
  );
}
